import React, { useEffect, useState } from 'react'
import { LangNew } from '../../constant/languange'
import { Spinner9 } from '../../helpers/Spinner'
import { checkAuthorization, connect, mapStateToProps, moment } from '../../helpers/Common'

/**
 *
 * @param releaseDate date:'YYYY-MM-DD'
 * @param DefaultBadge component
 * @returns component
 */
function BadgesParent({ type = 'link', releaseDate = '', DefaultBadge = null, redux, ...props }) {
  const [control, setControl] = useState({ newBadgeExpired: true, show: true })

  useEffect(() => {
    setControl(currControl => ({ ...currControl, newBadgeExpired: releaseDate !== '' ? moment().isSameOrAfter(moment(releaseDate).add(1, 'month'), 'day') : true }))
    let passLimitation = true
    let passCheckAuthorization = true
    let passCheckRoleAuthorization = true

    if (props.limitation) {
      if (props.limitation.length !== 0) {
        props.limitation.forEach(item => {
          if (redux.hasOwnProperty(item)) {
            // if (redux[item] === false) setControl(currControl => ({ ...currControl, show: false }))
            if (redux[item] === false) passLimitation = false
          }
        })
      }
    }
    if (props.checkAuthorization) {
      if (props.checkAuthorization.length !== 0) {
        let authorizedCount = 0
        props.checkAuthorization.forEach(item => {
          if (checkAuthorization(redux, item)) {
            authorizedCount += 1
          }
        })
        // setControl(currControl => ({ ...currControl, show: authorizedCount > 0 }))
        passCheckAuthorization = authorizedCount > 0
      }
    }
    if (props.checkRoleAuthorization) {
      if (redux.profile.role_id !== props.checkRoleAuthorization) {
        // setControl(currControl => ({ ...currControl, show: false }))
        passCheckRoleAuthorization = false
      }
    }

    setControl(currControl => ({ ...currControl, show: passLimitation && passCheckAuthorization && passCheckRoleAuthorization }))
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {!control.newBadgeExpired && control.show
        ? <div style={{ fontSize: '9px' }} className={`badge badge-secondary ${type === 'sub' && 'mr-3'} position-static py-1 d-flex align-items-center mr-1`}>{Spinner9({ size: 9 })} <span className='font-weight-bold' style={{ color: 'inherit' }}>{LangNew.toUpperCase()}</span></div>
        : DefaultBadge}
    </>
  )
}

export default connect(mapStateToProps)(BadgesParent)
